/**
 * SITE-DELETE.MODAL
 */
import ModalConfirm from "@/components/modal-confirm"
import { t } from "i18next"
import siteStore from "../../model/site.store"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { toast } from "react-toastify"
import populationStore from "@/entities/population/model/population.store"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"

interface Props {
  onClose: () => void
}

export default function SiteDeleteModal(props: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const site = useAppSelector(siteStore.selectors.draft)
  const populationsForSite = useAppSelector(populationStore.selectors.listForSite)
  const risksForSite = useAppSelector(physicalRiskStore.selectors.listForSite)
  const siteTypeLabel = site.geometryType === "line" ? "cette circulation" : "ce lieu de travail"

  //Remove site
  async function confirmDelete() {
    const response = await dispatch(siteStore.thunks.removeEntity(site.id))
    if (response?.type !== "site/remove/rejected") {
      props.onClose()
    }
  }

  function handleDelete() {
    let message = ""
    if (populationsForSite.length) {
      message = "des fonctions sont associées."
    } else if (risksForSite.length) {
      message = "des risques sont associées."
    }

    if (message) {
      return toast(`Impossible de supprimer ${siteTypeLabel} : ${message}`, { type: "error" })
    } else {
      confirmDelete()
    }
  }

  return (
    <ModalConfirm
      onNo={() => props.onClose()}
      onYes={handleDelete}
      textBold={t("utils_next_ask")}
      text={`Vous êtes sur le point de supprimer ${site.geometryType === "line" ? "la circulation" : "le lieu de travail"} « ${site.name} ».`}
    />
  )
}
